import { render, staticRenderFns } from "./Treated.vue?vue&type=template&id=33e81e7e&scoped=true"
import script from "./Treated.vue?vue&type=script&lang=js"
export * from "./Treated.vue?vue&type=script&lang=js"
import style0 from "./Treated.vue?vue&type=style&index=0&id=33e81e7e&prod&scoped=true&lang=css"
import style1 from "./Treated.vue?vue&type=style&index=1&id=33e81e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e81e7e",
  null
  
)

export default component.exports